<div class="avi-alert-bell-footer">
    <cds-button
        action="flat"
        class="avi-alert-bell-footer__view-alerts"
        (click)="handleViewAllAlertsClick()"
    >
        {{ globalL10nKeys.viewAlertLabel | vtranslate }}
    </cds-button>
</div>
